import React from "react";
import classNames from "classnames/bind";
import { IconColours } from "../../Foundation/Icons/interface";
import NavButton from "./NavButton";
import NavLink from "./NavLink";
import { NavLinkProps, NavButtonProps, NavigationProps } from "./interface";
import classes from "./navigation.module.scss";

// Define a type guard function to check if a link is a NavButtonProps
const isNavButtonProps = (
    link: NavLinkProps | NavButtonProps
): link is NavButtonProps => {
    return "size" in link;
};

const Navigation = ({
    links,
    orientation = "horizontalNav",
    theme = "",
    iconColour = IconColours.black,
    featureAttribution,
    useInternalScroll = true,
    navIconElement,
}: NavigationProps) => {
    const navItems = links?.map((link, i) => {
        const featureAttributionWithPosition = featureAttribution
            ? {
                  instance: featureAttribution?.instance,
                  name: featureAttribution?.name,
                  position: (i + 1).toString(),
                  value: link?.label,
              }
            : undefined;

        return (
            <li key={`horizontalNav-link-${link.label}`}>
                {isNavButtonProps(link) && (
                    <NavButton
                        orientation={orientation}
                        theme={theme}
                        iconColour={iconColour}
                        {...link}
                    />
                )}
                {!isNavButtonProps(link) && (
                    <NavLink
                        orientation={orientation}
                        theme={theme}
                        featureAttribution={featureAttributionWithPosition}
                        {...link}
                    />
                )}
            </li>
        );
    });

    const cx = classNames.bind(classes);
    const navigationClasses = cx({
        navigation: true,
        [orientation]: !!orientation,
        [theme]: !!theme,
        useInternalScroll,
    });

    return (
        <nav data-testid="nav-list" className={navigationClasses}>
            <ul>
                {navIconElement && (
                    <li key="horizontalNav-icon">{navIconElement}</li>
                )}
                {navItems}
            </ul>
        </nav>
    );
};
export default Navigation;
